import { useState } from "react";
import { ICellRendererParams } from "ag-grid-community";
import CustomModal from "./CustomModal";
import { DealsGridContext } from "../../types/DealTracker";

export default function FlowCellRenderer(
  params: ICellRendererParams<any, any, DealsGridContext>
) {
  const { flowTemplates, permission } = params.context;
  const isReadOnly = !["owner", "editor"].includes(permission);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pendingValue, setPendingValue] = useState<string | null>(null);

  const toggleModal = () => {
    setIsModalOpen((prev) => !prev);
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newValue = e.target.value;

    if (params.value) {
      setPendingValue(newValue);
      toggleModal();
      return;
    }

    params.node.setDataValue("flow", newValue);
  };

  const handleConfirm = () => {
    if (pendingValue) {
      params.node.setDataValue("flow", pendingValue);
      setPendingValue(null);
    }
    toggleModal();
  };

  if (!flowTemplates) return <p className="text-gray-500">loading..</p>;

  return (
    <>
      <select
        value={params?.value || ""}
        onChange={handleChange}
        className="w-full h-full rounded-md bg-transparent px-2 py-1 text-sm text-gray-700 focus:border-none focus:ring-0 focus:outline-none"
        disabled={isReadOnly}
      >
        <option value="" disabled className="text-gray-400">
          Select flow
        </option>
        {flowTemplates.map((el) => (
          <option key={el.id} value={el.id}>
            {el.title}
          </option>
        ))}
      </select>

      <CustomModal open={isModalOpen} onClose={toggleModal}>
        <div className="space-y-4">
          <h1 className="font-medium text-xl text-gray-950">
            ⚠️ This action will reset your current flow
          </h1>
          <p className="text-sm text-gray-900">
            All existing steps and progress linked to this flow will be cleared.
            Do you want to proceed?
          </p>

          <div className="flex gap-4">
            <button
              className="w-full bg-red-500 text-white p-2 cursor-pointer rounded-xl"
              onClick={handleConfirm}
            >
              Yes
            </button>
            <button
              className="w-full text-gray-900 p-2 cursor-pointer border border-gray-900 rounded-xl"
              onClick={toggleModal}
            >
              No
            </button>
          </div>
        </div>
      </CustomModal>
    </>
  );
}
